import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import SchemaFields from '../add-customer-schema-fields';

interface BillingProps {
  schema: any;
  handleChange: any;
  values: any;
  formikErrors: any;
  touched: any;
  formik: any;
  updating: boolean;
}

const useStyles = makeStyles(() => ({
  container: { height: '100%', justifyContent: 'space-between' },
}));

const FormCustomerInfo: React.FC<BillingProps> = ({
  schema,
  handleChange,
  values,
  formikErrors,
  touched,
  formik,
  updating,
}: BillingProps) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid item>
        <Typography>{schema.label}</Typography>
      </Grid>
      <Grid item container spacing={2}>
        {schema.fields.map((field: any, i: number) => {
          return (
            <Grid
              key={field.name + i}
              item
              style={{ width: field.fullWidth ? '100%' : '50%' }}
            >
              <SchemaFields
                formikErrors={formikErrors}
                key={field.name + i}
                input={field}
                handleChange={handleChange}
                values={values}
                formik={formik}
                touched={touched}
                updating={updating}
              ></SchemaFields>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default FormCustomerInfo;
